import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const InviteUserIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.75 12.75H23.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 10.5V15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.125 15C13.2316 15 15.75 12.4816 15.75 9.375C15.75 6.2684 13.2316 3.75 10.125 3.75C7.0184 3.75 4.5 6.2684 4.5 9.375C4.5 12.4816 7.0184 15 10.125 15Z" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M2.08124 18.75C3.06679 17.5754 4.29765 16.6309 5.6873 15.9828C7.07695 15.3348 8.59166 14.999 10.125 14.999C11.6583 14.999 13.173 15.3348 14.5627 15.9828C15.9523 16.6309 17.1832 17.5754 18.1687 18.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(InviteUserIcon);
